let painScaleType;
addEventListener('setVitalSignPainScaleType', (e) => {
    const ce = e;
    painScaleType = ce.detail.painScaleType;
});
export const VITAL_SIGN_PAIN_SCALE_VALIDATOR = 'vital-sign-pain-scale-validator';
async function vitalSignPainScaleValidator(value) {
    let valid = false;
    let message = '';
    if (painScaleType && painScaleType.cd?.length > 0) {
        if (typeof value === 'string') {
            valid = (value.length > 0 && parseFloat(value) >= 0);
        }
        else {
            valid = (value || value >= 0);
        }
    }
    else {
        valid = true;
    }
    if (!valid) {
        message = '$expression.$609525';
    }
    const event = new CustomEvent('applyVitalSignValidation');
    dispatchEvent(event);
    painScaleType = undefined;
    return [{
            message: message,
            name: VITAL_SIGN_PAIN_SCALE_VALIDATOR,
            valid: valid
        }];
}
export default vitalSignPainScaleValidator;
//# sourceMappingURL=vital-sign-pain-scale-validator.js.map